
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.174.95c.082-.412.298-.677.592-.812.239-.11.519-.12.809-.045.252.065.517.199.77.39.687.517 1.33 1.492 1.412 2.71.025.376.018.776-.017 1.202-.024.281-.06.577-.11.884h2.922l.013.001c.475.02.935.134 1.323.334.335.173.618.411.814.707.203.304.313.666.296 1.08a2.518 2.518 0 01-.265.996c.097.4.142.829.08 1.206-.053.32-.18.604-.405.815.012.53-.06.973-.204 1.357a2.834 2.834 0 01-.653 1.01 4.095 4.095 0 01-.13.723c-.08.284-.2.544-.365.775-.498.695-.896.68-1.528.653-.088-.003-.181-.007-.328-.007H8.483c-.514 0-.919-.074-1.288-.257-.364-.18-.676-.459-1.009-.87l-.085-.24V6.967l.29-.076c.737-.198 1.317-.82 1.768-1.567.463-.768.788-1.666 1.01-2.392V1.025L9.175.95zM.586 6.28h4.26c.322 0 .586.26.586.58v7.703c0 .32-.264.58-.586.58H.586a.584.584 0 01-.586-.58V6.858c0-.319.264-.58.586-.58z","fill":"#8DC540"}})])
          )
        }
      }
    